import React, { useContext, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import overlayFactory from 'react-bootstrap-table2-overlay';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { useTranslation } from 'react-i18next';
import { NavLink, useHistory } from "react-router-dom";
import { removeVisit, swapVisits } from '../../../api/protocol';
import { WithAuth } from '../../../components/Authorization/WithAuthProtocol';
import Card from '../../../components/Cards/Card';
import { CustomSelect } from '../../../components/CustomControls/CustomSelect';
import { Add, Copy, Down, Edit, Remove, Up, View } from '../../../components/Icons/Icons';
import { HandleApiError } from "../../../components/Notifications/APIErrorHandler";
import { Success } from '../../../components/Notifications/Notifications';
import { OffsetTypes, VisitStages } from '../../../components/Protocols/Visit/Enums';
import { Tooltip } from "../../../components/Utils/Tooltips";
import ProtocolContext from '../ProtocolContext/ProtocolContext';
import { AddVisitModal, CopyVisitModal } from './CreateVisit';
import { EditVisitModal } from './EditVisit';
import { RemoveModal } from './RemoveVisit';
import { useAllVisits } from './useVisits';
import { CopyVisitsContainer } from './CopyVisits';
import { ModalData } from '../../../components/Modals/ModalData';
import { VisitSheetsTabs } from '../Branches';

export const ProtocolVisitsContainer = ({ protocolId, branchesVersion }) => {
    const { t } = useTranslation();
    const context = useContext(ProtocolContext);
    let history = useHistory();
    const [setData, data, query, totalSize, isLoading, handleTableChange, handleFilterChange, setReload] = useAllVisits(protocolId);

    const columns = [
        {
            dataField: 'sortViews',
            text: '',
            isDummyField: true,
            headerClasses: 'header-swap-btn',
            formatter: function (_cell, _row, rowIndex, _formatExtraData) {
                if (context.isDisabled) return null;
                return (
                    <div key={"sort" + rowIndex}>
                        <WithAuth protocolId={protocolId} requiredPermission={["Visits.Add"]}>
                            {
                                data.length !== rowIndex + 1 ?
                                    <button
                                        type="button"
                                        className="btn-table-actions btn-swap"
                                        style={{ paddingRight: '1px' }}
                                        onClick={() => handleSwapVisit(rowIndex, rowIndex + 1)} >
                                        <Down />
                                    </button>
                                    : ""
                            }
                            {
                                0 !== rowIndex ?
                                    <button
                                        type="button"
                                        className="btn-table-actions btn-swap"
                                        style={{ paddingRight: '1px' }}
                                        onClick={() => handleSwapVisit(rowIndex, rowIndex - 1)} >
                                        <Up />
                                    </button>
                                    : ""
                            }
                        </WithAuth>
                    </div>
                )
            }
        },
        { dataField: 'order', text: t("protocols.visit.visitOrder") },
        { dataField: 'title', text: t("protocols.visit.visitName") },
        { dataField: 'version', text: t("protocols.visit.visitVersion") },
        {
            dataField: 'offset', text: t("protocols.visit.visitOffset"),
            formatter: function (cell, row) {
                return `${cell} ${OffsetTypes().find(x => x.id === row.offsetType)?.title}`;
            }
        },
        {
            dataField: 'stage', text: t("protocols.visit.visitStage"),
            formatter: function (cell) {
                return VisitStages().find(x => x.id === cell)?.title;
            }
        },
        {
            dataField: 'view',
            text: t("commons.actions"),
            isDummyField: true,
            headerClasses: 'header-visit-actions',
            classes: 'row-visit-actions',
            formatter: function (_cell, row, rowIndex) {
                return (
                    <div key={rowIndex}>
                        {
                            !context.isDisabled &&
                            <WithAuth protocolId={protocolId} requiredPermission={["Visits.Add"]}>
                                <Tooltip tooltip={t("protocols.visit.actionEdit")} id={"tooltipedit-" + row.crossVersionId}>
                                    <button onClick={() => handleEditVisit(row.crossVersionId)} className="btn-table-actions">
                                        <Edit />
                                    </button>
                                </Tooltip>
                                <Tooltip tooltip={t("protocols.visit.actionCopy")} id={"tooltipcopy-" + row.crossVersionId}>
                                    <button onClick={() => handleCopyVisit(row.crossVersionId)} className="btn-table-actions">
                                        <Copy />
                                    </button>
                                </Tooltip>
                            </WithAuth>
                        }

                        <Tooltip tooltip={t("protocols.visit.actionView")} id={"tooltipconfig-" + row.crossVersionId}>
                            <NavLink to={`/admin/protocols/${row.protocolId}/visitsTemplate/${row.crossVersionId}`} className="btn-table-actions" activeClassName="active">
                                <View />
                            </NavLink>
                        </Tooltip>

                        {
                            !context.isDisabled &&
                            <WithAuth protocolId={protocolId} requiredPermission={["Visits.Add"]}>
                                <Tooltip tooltip={t("protocols.visit.actionRemove")} id={"tooltipremove-" + row.crossVersionId}>
                                    <button className="btn-remove btn-table-actions" onClick={() => handleRemoveVisit(row.crossVersionId)}>
                                        <Remove />
                                    </button>
                                </Tooltip>
                            </WithAuth>
                        }
                    </div>
                )
            }
        }
    ];

    const handleSwapVisit = (oldIndex, newIndex) => {

        swapVisits(protocolId, data[oldIndex].crossVersionId, data[newIndex].crossVersionId)
            .then(() => {
                // Hago swap en cliente. 
                let copiedVisits = JSON.parse(JSON.stringify(data));

                copiedVisits[oldIndex].order = (data[newIndex].order);
                copiedVisits[newIndex].order = (data[oldIndex].order);

                setData(copiedVisits.sort((function (a, b) { return a.order - b.order; })));
            })
            .catch(error => {
                HandleApiError(error);
            });
    };

    const [modal, setModal] = useState(null);
    const handleRemoveVisit = (visitId) => {
        console.log(visitId)
        setModal(<RemoveModal
            id={visitId}
            title={t("commons.areyousure")}
            onClose={() => { setModal(null); }}
            onConfirm={handleConfirmRemove} />)
    }
    const handleConfirmRemove = (visitId) => {
        if (visitId) {
            removeVisit(protocolId, visitId)
                .then(() => {
                    let copiedData = JSON.parse(JSON.stringify(data));
                    setData(copiedData.filter(obj => obj.crossVersionId !== visitId));
                    Success("protocolNotifications.visit_Removed");
                    setModal(null);
                }).catch(error => {
                    console.error(error);
                    HandleApiError(error);
                    setModal(null);
                });
        }
        setModal(null);
    }

    const handleAddVisit = () => {
        setModal(<AddVisitModal
            protocolId={protocolId}
            hide={() => setModal(null)}
            submit={() => history.push(`/admin/protocols/${protocolId}/visitsTemplate/`)}
            isShowing={true} />);
    }

    const handleEditVisit = (visitId) => {
        setModal(<EditVisitModal
            protocolId={protocolId}
            visitId={visitId}
            hide={() => setModal(null)}
            submit={() => history.push(`/admin/protocols/${protocolId}/visitsTemplate/${visitId}`)}
            onBranchSaved={() => setReload(true)}
            isShowing={true} />);
    }

    const handleCopyVisit = (visitId) => {
        setModal(<CopyVisitModal
            protocolId={protocolId}
            visitId={visitId}
            hide={() => setModal(null)}
            submit={() => history.push(`/admin/protocols/${protocolId}/visitsTemplate/`)}
            isShowing={true} />);
    }

    //#region CopyVisits
    const handleCopyVisits = () => {
        setModal(<ModalData
            title={t("protocols.visit.copyVisits_title")}
            isShowing={true}
            size="medium"
            className=""
            hide={() => setModal(null)}
        >
            <CopyVisitsContainer protocolId={protocolId} onClose={() => { setReload(true); setModal(null) }} />
        </ModalData>
        );
    }

    //#endregion

    return (
        <Card
            header={
                <div className="row">
                    <div className="col-md-2">
                        <WithAuth protocolId={protocolId} requiredPermission={["Visits.Add"]}>
                            <button onClick={handleAddVisit} className="btn btn-primary" disabled={context.isDisabled}>
                                <Add /> {t('protocols.visit.addVisit')}
                            </button>
                        </WithAuth>
                    </div>
                    <div className="col-md-3">
                        <WithAuth protocolId={protocolId} requiredPermission={["Visits.Add"]}>
                            <button onClick={handleCopyVisits} className="btn btn-primary" disabled={context.isDisabled}>
                                <Copy /> {t('protocols.visit.copyVisits')}
                            </button>
                        </WithAuth>
                    </div>
                    <div className="col-md-5">
                    </div>
                    <div className="col-md-2">
                        <CustomSelect
                            name="stage"
                            placeholder="Etapas"
                            onChange={handleFilterChange}
                            isMulti={false}
                            isClearable={true}
                            options={VisitStages()} />
                    </div>

                </div>
            }
            content={
                <div>
                    {modal}
                    <VisitSheetsTabs
                        protocolId={protocolId}
                        visits={data}
                        refreshKey={branchesVersion}
                        renderVisits={(visitsForTab) => (
                            <BootstrapTable
                                classes="table-spaced table-spaced-small"
                                wrapperClasses="table-responsive"
                                bordered={false}
                                hover
                                keyField='id'
                                data={visitsForTab}
                                columns={columns}
                                noDataIndication={() => <>{t("commons.noData")}</>}
                                loading={isLoading}
                                overlay={overlayFactory({ spinner: true })}
                                pagination={paginationFactory({
                                    sizePerPage: 10,
                                    hideSizePerPage: true,
                                })}
                            />
                        )}
                    />
                </div>
            }
        />
    );
}